import React, { useRef, useState } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import { inputId, inputName } from '../../../helper/form';
import FieldError from '../../../helper/FieldError';

const ComplianceActivityEvidenceChild = (props) => {
  const {
    index,
    parentIndex,
    child,
    configuration: {
      formName
    },
    callbacks: {
      onChangeChildren: callbackOnChangeChildren,
      onDestroyChild: callbackOnDestroyChild
    }
  } = props;

  const fileInputRef = useRef(null);
  const [isFileLoaded, setIsFileLoaded] = useState(false);

  const onChangeChild = (event, key) => {
    let _child = { ...child };
    let value = event.target.value;

    if(event.target.type == 'checkbox'){
      value = event.target.checked;
    }

    if(event.target.type == 'file'){
      value = event.target.files[0];
      setIsFileLoaded(!!value);
    }

    _child[key] = value;

    if(_.isFunction(callbackOnChangeChildren)){
      callbackOnChangeChildren(index, _child)
    }
  }

  const onChangeChildFile = (event) => {
    onChangeChild(event, 'template');
  }

  return (
    <div className="nested-fields">
      <div className="nested-items">
        <div className="card bg-real-light">
          <div className="card-body">
            <div className="row justify-content-between">
              <div className="col-md-6">
                <FormGroup>
                  <Label for={ inputId(formName, 'name') }>
                    Evidencia
                  </Label>
                </FormGroup>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-end">
                  <div className="custom-switch mr-5">
                    <FieldError errors={ child?.errors?.is_recurrent || [] }>
                      <Input
                        type='checkbox'
                        className='custom-control-input'
                        id={ inputId(formName, 'is_recurrent') }
                        name={ inputName(formName, 'is_recurrent') }
                        checked={ child?.is_recurrent || false }
                        invalid={ _.has(child?.errors, 'is_recurrent') }
                        onChange={ e => onChangeChild(e, 'is_recurrent') }
                      />
                      <Label
                        className='custom-control-label'
                        for={ inputId(formName, 'is_recurrent') }
                      >
                        { I18n.t('activerecord.attributes.compliance/evidence.is_recurrent') }
                      </Label>
                    </FieldError>
                  </div>
                  <div className="text-end">
                    <Button
                      color='danger'
                      size='sm'
                      onClick={ e => callbackOnDestroyChild(index) }
                      outline
                      title='Eliminar evidencia complementaria'
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-md-10">
                <FormGroup>
                  <FieldError errors={ child?.errors?.name || [] }>
                    <Input
                      type='text'
                      id={ inputId(formName, 'name') }
                      name={ inputName(formName, 'name') }
                      placeholder="Nombre de evidencia"
                      invalid={ _.has(child?.errors, 'name') }
                      value={ child?.name || '' }
                      onChange={ e => onChangeChild(e, 'name') }
                    />
                  </FieldError>
                </FormGroup>
              </div>
              <div className="col-md-2">
                <Input
                  innerRef={fileInputRef}
                  type='file'
                  id={ inputId(formName, 'template') }
                  name={ inputName(formName, 'template') }
                  className='d-none'
                  onChange={ onChangeChildFile }
                />
                <span className="mx-2">o</span>
                <Label
                  for={ inputId(formName, 'template') }
                  className={`btn btn-sm text-end ${isFileLoaded ? 'btn-info' : 'btn-outline-info'}`}
                  style={{ cursor: 'pointer' }}
                >
                  {isFileLoaded ? (
                    <>
                      <i className="fas fa-check mr-2"></i>
                      cargado
                    </>
                  ) : (
                    <>
                      <i className="fas fa-upload mr-2"></i>
                      { I18n.t('actions.upload_template') }
                    </>
                  )}
                </Label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComplianceActivityEvidenceChild;
